import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Tabs from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Tabs';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Tab from 'Components/ComponentLibrary/Molecules/Tabs/Tab';
import TabSubLabel from 'Components/ComponentLibrary/Molecules/Tabs/TabSubLabel';
import TabLabel from 'Components/ComponentLibrary/Molecules/Tabs/TabLabel';

const styles = theme => ({
  root: {},
  wrapper: {},
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    borderRadius: theme.radius.full,
  },
  warning: {
    color: theme.palette.facet.warning,
  },
  indicatorPrimaryColor: {
    backgroundColor: theme.palette.primary.main,
  },
  indicatorSeafoamColor: {
    backgroundColor: theme.palette.facet.seafoam,
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  labelVertical: {
    maxWidth: '50px', // cause the label to wrap
  },
  label: {},
});

// DEPRECATED: Use design-system Tabs
const FacetTabs = ({
  centered,
  className,
  classes,
  indicatorColor,
  tabs,
  onChange,
  size,
  textColor,
  variant,
  value,
  TabProps,
  orientation,
}) => {
  return (
    <Box className={classNames(classes.root, className)}>
      <Tabs
        className={classes.tabs}
        classes={{
          indicator: classNames(classes.indicator, {
            [classes.indicatorPrimaryColor]: indicatorColor === 'primary',
            [classes.indicatorSeafoamColor]: indicatorColor === 'seafoam',
          }),
        }}
        centered={centered}
        onChange={onChange}
        orientation={orientation}
        scrollButtons={variant === 'scrollable' ? 'auto' : 'off'}
        textColor={'inherit'}
        value={value}
        variant={variant}
      >
        {tabs.map(tab => {
          return (
            !tab.isHidden && (
              <Tab
                size={size}
                key={tab.key}
                actionNeeded={tab.actionNeeded}
                errorCount={tab.errorCount}
                warningCount={tab.warningCount}
                value={tab.value}
                icon={tab.icon}
                label={
                  <Box className={classes.labelContainer}>
                    <TabLabel
                      classes={{
                        label: classNames(classes.label, {
                          [classes.labelVertical]: orientation === 'vertical',
                        }),
                      }}
                      label={tab.label}
                      size={size}
                      textColor={textColor}
                    />
                    {tab.subLabel && (
                      <TabSubLabel label={tab.subLabel} size={size} />
                    )}
                  </Box>
                }
                disabled={tab.disabled}
                test={`facet-tab-${tab.label}`}
                {...TabProps}
              />
            )
          );
        })}
      </Tabs>
    </Box>
  );
};

FacetTabs.defaultProps = {
  centered: false,
  className: '',
  indicatorColor: 'primary',
  size: 'md',
  variant: 'scrollable',
  orientation: 'horizontal',
  textColor: 'primary',
  value: undefined,
  TabProps: {},
};

FacetTabs.propTypes = {
  centered: PropTypes.bool,
  className: PropTypes.string,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  variant: PropTypes.string,
  classes: PropTypes.object.isRequired,
  indicatorColor: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      isHidden: PropTypes.bool,
      label: PropTypes.string.isRequired,
      actionNeeded: PropTypes.bool,
      subLabel: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['sm', 'md']),
  textColor: PropTypes.string,
  value: PropTypes.string,
  TabProps: PropTypes.object,
};

export default withStyles(styles)(FacetTabs);
